<script setup>
  import SpecGrid from './Parts/SpecGrid.vue'
</script>
<template>
    <div class="content">
      <h1>About Me</h1>
      <SpecGrid :specs="Skills" title="Skills" />       
      <p>I will write about what tech i know, where i have worked, what i have learnt, what i want to learm, what i want to do, what i have acheived etc here.</p>
    </div>
</template>

<script>
  export default {
    components: {
      SpecGrid
    },
    data() {
      return {
        Skills: [
          { component: "Will Fill in soon", spec: "placeholder" },
          
        ]
      };
    }
  };
</script>
